import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { EstatePlanningDocumentDTO } from '../../../../types/goalsDTO';
import { queryClient } from '../../../../../../config/queryClient';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';
import { useIsPdf } from '../../../../hooks/useIsPdf';
import { useClientId } from '../../../../../_hooks/useClientId';

interface CreateOrUpdateEstatePlanningDocumentParams extends EstatePlanningDocumentDTO {
  clientId: string;
}

const createOrUpdateEstatePlanningDocument = (
  params: CreateOrUpdateEstatePlanningDocumentParams,
) => {
  const body = new FormData();

  if (params.Id) {
    body.append('id', params.Id);
  }

  body.append('json', JSON.stringify({ ...params, documentType: params.DocumentType }));

  return authFetch('/Consumer/EstatePlanning', {
    method: params.Id ? 'PUT' : 'POST',
    body,
  });
};

export const useCreateOrUpdateEstatePlanningDocumentMutation = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  const isPdf = useIsPdf();

  return useMutation(createOrUpdateEstatePlanningDocument, {
    onSuccess: async () => {
      const queryKey = queryKeys.financialPlan(clientId, fpId, isPdf);

      await queryClient.invalidateQueries(queryKey);
    },
  });
};
